/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Vehicle_Crlv_AcceptInputs */

const en_case_section_vehicle_crlv_accept = /** @type {(inputs: Case_Section_Vehicle_Crlv_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital CRLV PDF · up to 5 MB`)
};

const pt_br2_case_section_vehicle_crlv_accept = /** @type {(inputs: Case_Section_Vehicle_Crlv_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF do CRLV digital · até 5 MB`)
};

/**
* | output |
* | --- |
* | "Digital CRLV PDF · up to 5 MB" |
*
* @param {Case_Section_Vehicle_Crlv_AcceptInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_vehicle_crlv_accept = /** @type {((inputs?: Case_Section_Vehicle_Crlv_AcceptInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Vehicle_Crlv_AcceptInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_vehicle_crlv_accept(inputs)
	return pt_br2_case_section_vehicle_crlv_accept(inputs)
});